import React from 'react';
import { CheckCircle2, XCircle, AlertTriangle } from 'lucide-react';

// >150 green = Excess | >125 yellow = OK | >100 orange = Warning | ≤100 red = Critical
// Ranges: >=150 Excess | >=125 and <150 OK | >=100 and <125 Warning | <100 Critical
const getCriticalityStyles = (stockCriticality) => {
    const val = Number(stockCriticality) || 0;
    if (val >= 150) return { border: 'border-l-green-500', icon: 'text-green-500', Icon: CheckCircle2, status: 'Excess', badge: 'bg-green-100 border-green-300 text-green-800' };
    if (val >= 125) return { border: 'border-l-yellow-400', icon: 'text-yellow-500', Icon: CheckCircle2, status: 'OK', badge: 'bg-yellow-100 border-yellow-300 text-yellow-800' };
    if (val >= 100) return { border: 'border-l-orange-400', icon: 'text-orange-500', Icon: AlertTriangle, status: 'Warning', badge: 'bg-orange-100 border-orange-300 text-orange-800' };
    return { border: 'border-l-red-500', icon: 'text-red-500', Icon: XCircle, status: 'Critical', badge: 'bg-red-100 border-red-300 text-red-800' };
};

const MaterialCard = ({ data }) => {
    const {
        name,
        unit,
        opening,
        purchased,
        consumed,
        closing,
        totalSpend,
        stock_criticality = 0
    } = data;

    const criticalityStyles = getCriticalityStyles(stock_criticality);
    const StatusIcon = criticalityStyles.Icon;

    const renderIcon = () => (
        <StatusIcon className={`w-6 h-6 ${criticalityStyles.icon}`} />
    );

    const getBorderColor = () => criticalityStyles.border;

    return (
        <div className={`flex flex-col md:flex-row items-center bg-white rounded-3xl shadow-sm border border-gray-100 p-4 md:py-6 md:px-8 mb-4 relative overflow-hidden border-l-[6px] ${getBorderColor()}`}>

            {/* Left Icon & Name */}
            <div className="flex items-center w-full md:w-[22%] mb-4 md:mb-0 gap-4">
                <div className="flex-shrink-0 transform scale-110">
                    {renderIcon()}
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 text-lg">{name}</h3>
                    <p className="text-sm text-gray-400 font-medium">{unit}</p>
                </div>
            </div>

            {/* Metrics */}
            <div className="flex flex-1 w-full justify-between items-center gap-2 md:gap-10 mb-4 md:mb-0 pr-8">
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500 font-medium mb-1">Opening</span>
                    <span className="text-base font-semibold text-gray-800">{opening}</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500 font-medium mb-1">Purchased</span>
                    <span className="text-base font-semibold text-gray-800">+{purchased}</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500 font-medium mb-1">Consumed</span>
                    <span className="text-base font-semibold text-gray-800">-{consumed}</span>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500 font-medium mb-1">Closing</span>
                    <span className="text-base font-semibold text-gray-800">{closing}</span>
                </div>
            </div>

            {/* Spend & Status */}
            <div className="flex w-full md:w-auto items-center justify-between md:justify-end gap-6 md:gap-10 pl-0 md:pl-8 md:border-l-2 md:border-gray-300 h-10">
                <div className="flex flex-col min-w-[120px] justify-center">
                    <span className="text-sm text-gray-500 font-medium mb-0.5">Total Spend</span>
                    <span className="text-xl font-bold text-gray-900">₹ {(totalSpend ?? 0).toLocaleString('en-IN')}</span>
                </div>

                <div className="h-full w-[2px] bg-gray-300 mx-2 hidden md:block"></div>

                <div className={`flex items-center px-4 py-1.5 rounded-lg border ${criticalityStyles.badge} min-w-[140px] justify-between h-10`}>
                    <span className="text-sm font-semibold">{criticalityStyles.status}</span>
                    <span className="text-sm font-bold ml-2">{stock_criticality ?? '0'}</span>
                </div>
            </div>
        </div>
    );
};

export default MaterialCard;
